import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { InjectedFormProps, Field } from 'redux-form';
import { IModalAction } from 'models/modal';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import { IUserListItem } from 'models/user/userlistitem';
import { WhiteButton } from 'components';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ImageUpload, PortalInputField } from 'components/FormControls';
import { PortalPageSection } from 'components/PortalStructure';
import { IUserCard } from 'models/user/usercard';

interface IProps extends InjectedFormProps {
	currentFormValues?: IPortalPageSection;
	section?: IPortalPageSection;
	index?: number;
	baseUrl?: string;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
	change?: any;
	setError: (error: any) => void;
	clearError: () => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ManageSectionItemProfile extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);

		this.searchProfile = this.searchProfile.bind(this);
		this.selectProfile = this.selectProfile.bind(this);
	}

	private initData() {
		if (
			this.props.currentFormValues &&
			this.props.currentFormValues.items &&
			!this.props.currentFormValues.items[this.props.index]
		) {
			this.props.change('items[' + this.props.index + '].type', c.PORTAL_PAGE_SECTION_ITEM_PROFILE);
			this.props.change('items[' + this.props.index + '].elements', []);
			this.props.change('items[' + this.props.index + '].elements[0]', { imageUrl: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[1]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[2]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[3]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[4]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[5]', { text: null, redirectUrl: null });
			this.props.change('items[' + this.props.index + '].elements[6]', { text: null, redirectUrl: null });
		}
	}

	public componentDidMount() {
		this.initData();
	}

	public componentDidUpdate() {
		this.initData();
	}

	private searchProfile(e: any, func: (data: IUserListItem) => void) {
		e.preventDefault();
		this.props.showModal('SearchProfiles', {
			selectProfile: func,
			closeModal: this.props.closeModal,
			showHeaderCloseButton: true,
		});
	}

	private selectProfile(data: IUserCard) {
		this.props.closeModal();

		this.props.change('items[' + this.props.index + '].elements[0]', { imageUrl: data.picture, redirectUrl: null });
		this.props.change('items[' + this.props.index + '].elements[1]', { text: data.name, redirectUrl: null });
		this.props.change('items[' + this.props.index + '].elements[2]', { text: data.location, redirectUrl: null });
		this.props.change('items[' + this.props.index + '].elements[3]', {
			text: data.shortDescription,
			redirectUrl: null,
		});
		this.props.change('items[' + this.props.index + '].elements[4]', { text: data.code, redirectUrl: null });
		this.props.change('items[' + this.props.index + '].elements[5]', { text: data.followersCount, redirectUrl: null });
		this.props.change('items[' + this.props.index + '].elements[6]', { text: data.entityId, redirectUrl: null });
	}

	public render() {
		const { t, currentFormValues, index } = this.props;

		if (currentFormValues && !currentFormValues.items[index]) {
			return <div>Empty :(</div>;
		}

		return (
			<PortalPageSection usage="admin">
				<div className="row">
					<div className="col-md-12">
						<WhiteButton
							type="submit"
							usage="admin"
							onClick={(event: any) => this.searchProfile(event, this.selectProfile)}
						>
							{t('PortalPage_Section_Manage_Common_SearchProfile')}
						</WhiteButton>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<Field
							name="imageUpload1"
							component={ImageUpload}
							additionalData={['items[' + this.props.index + '].elements[0].imageUrl']}
							existingImageUrl={
								currentFormValues &&
								currentFormValues.items &&
								currentFormValues.items.length > 0 &&
								currentFormValues.items[index] &&
								currentFormValues.items[index].elements &&
								currentFormValues.items[index].elements.length > 0 &&
								currentFormValues.items[index].elements[0]
									? (currentFormValues.items[index].elements[0] as ISectionImageElement).imageUrl
									: null
							}
							label={t('PortalPage_Section_Manage_Common_Picture')}
							readOnly={true}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<Field
							name={'items[' + index + '].elements[1].text'}
							component={PortalInputField}
							usage="admin"
							type="text"
							label={t('PortalPage_Section_Manage_Common_Name')}
							readOnly={true}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<Field
							name={'items[' + index + '].elements[2].text'}
							component={PortalInputField}
							usage="admin"
							type="text"
							label={t('PortalPage_Section_Manage_Common_Location')}
							readOnly={true}
						/>
					</div>
				</div>

				<div className="row">
					<div className="col-md-12">
						<Field
							name={'items[' + index + '].elements[3].text'}
							component={PortalInputField}
							usage="admin"
							type="text"
							label={t('PortalPage_Section_Manage_Common_ShortDescription')}
							readOnly={true}
						/>
					</div>
				</div>

				<Field name={'items[' + index + '].elements[4].text'} component="input" type="hidden" />
				<Field name={'items[' + index + '].elements[5].text'} component="input" type="hidden" />
			</PortalPageSection>
		);
	}
}

export { ManageSectionItemProfile };
